import React from 'react';
import { Tooltip as TooltipPrimitive } from 'radix-ui';
import { TooltipContent, TooltipProvider, TooltipRoot, TooltipTrigger } from '../../src/components/tooltip';

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & { label: string };

/** A labeled icon control with hover/focus help, including while disabled. */
export const TooltipButton = React.forwardRef<HTMLButtonElement, Props>(function TooltipButton(
  { label, disabled, children, ...props }, ref,
) {
  return <TooltipProvider>
    <TooltipRoot delayDuration={300}>
      <TooltipTrigger asChild>
      <span className="inline-flex shrink-0" tabIndex={disabled ? 0 : undefined} aria-label={disabled ? label : undefined} aria-disabled={disabled || undefined}>
        <button {...props} ref={ref} type={props.type || 'button'} title={undefined} aria-label={label} disabled={disabled}
          className={`${props.className || ''} disabled:pointer-events-none`}>
          {children}
        </button>
      </span>
      </TooltipTrigger>
      <TooltipPrimitive.Portal>
        <TooltipContent collisionPadding={8} className="z-[1000] max-w-[calc(100vw-2rem)] whitespace-normal break-words rounded-2xl sm:max-w-xs">{label}</TooltipContent>
      </TooltipPrimitive.Portal>
    </TooltipRoot>
  </TooltipProvider>;
});
